module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [(_vm.quiz) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h2', [_vm._v(" " + _vm._s(_vm.quiz.title) + " : Préconisations & Analyses")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 mt-20"
  }, [(_vm.quiz) ? _c('div', {
    staticClass: "portlet light portlet-fit portlet-form bordered col-xs-12 p-0"
  }, [_c('div', {
    staticClass: "portlet-title col-xs-12 "
  }, [_c('div', {
    staticClass: "caption tabbable-line p-0"
  }, [_c('ul', {
    staticClass: "nav nav-tabs "
  }, [_c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "aria-expanded": "false"
    },
    on: {
      "click": function($event) {
        _vm.show.list_actions = true
      }
    }
  }, [_c('i', {
    staticClass: " icon-layers"
  }), _vm._v(" "), _c('span', {
    staticClass: "caption-subject sbold uppercase"
  }, [_vm._v("Actions ")])])]), _vm._v(" "), _c('li', {}, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "aria-expanded": "true"
    },
    on: {
      "click": function($event) {
        _vm.show.analysis = true
      }
    }
  }, [_c('i', {
    staticClass: " icon-note"
  }), _vm._v(" "), _c('span', {
    staticClass: "caption-subject sbold uppercase"
  }, [_vm._v("Analyse")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "portlet-body col-xs-12"
  }, [(_vm.show.analysis) ? _c('analysis') : _vm._e(), _vm._v(" "), (_vm.show.list_actions) ? _c('list-actions', {
    attrs: {
      "quiz": _vm.quiz
    },
    on: {
      "update:quiz": function($event) {
        _vm.quiz = $event
      }
    }
  }) : _vm._e()], 1)]) : _c('div', {
    staticClass: "row m-0"
  }, [_c('div', {
    staticClass: "col-md-12 page-404 mt-50 pb-50"
  }, [_c('div', {
    staticClass: "number font-green"
  }, [_vm._v(" 404 ")]), _vm._v(" "), _c('div', {
    staticClass: "details"
  }, [_c('h3', [_vm._v("Oops ! Questionnaire non trouvé.")]), _vm._v(" "), _c('p', [_vm._v(" Nous n'avons pas réussi à trouver ce questionnaire.\n                      "), _c('br'), _vm._v("\n                      Vérifiez'url et tentez de recharger la page.\n                  ")])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d9b01eb8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/quizzes/preconizations.vue
// module id = 126
// module chunks = 0